import styled from 'styled-components';

import { PlusSvg } from '../../../assets/icons';
import theme from '../../../assets/theme';
import { Button } from '../Button';

const ExpandingButton = ({
  buttonText,
  icon,
  handleClick,
  style,
}: {
  buttonText: string;
  icon?: React.ReactElement;
  handleClick: () => void;
  style?: React.CSSProperties;
}) => {
  return (
    <StyledButton
      height="25px"
      onClick={() => handleClick()}
      icon={icon ? icon : <PlusSvg />}
      styles={style}
    >
      {buttonText}
    </StyledButton>
  );
};

export default ExpandingButton;

const StyledButton = styled(Button)`
  padding: 3px 5px;
  position: relative;
  border-radius: 50px;
  color: ${theme.colors.iconGrey};
  background-color: ${theme.colors.greyLight};
  width: 25px;
  overflow: hidden;
  display: flex;
  flex-direction: row-reverse;
  justify-content: end;
  span {
    margin-right: 25px;
    margin-left: 5px;
  }

  svg {
    position: absolute;
    right: 2px;
    top: 6px;
    height: 12px;
    width: 12px;
    color: ${theme.colors.greyDark};
  }

  &:hover {
    width: 150px;
    transition-delay: 0.5s !important;
    transition: width 0.5s ease-in-out;
    color: ${theme.colors.black};
    background-color: ${theme.colors.grey};

    svg {
      color: #000;
    }
  }

  &:focus {
    color: ${theme.colors.black};
    background-color: ${theme.colors.grey};
    svg {
      color: #000;
    }
  }
`;
